<script>

//const apiSrc = "https://enjoykaohsiung.thinker.tw";
//const subDirectory = "/Platform";

const apiSrc = "https://men-go.tw";
const subDirectory = "/Platform";

//const apiSrc = "https://localhost:44320";
//const subDirectory = "";

const QRCId = 31;
const localVer = "20260315.03";
export default {
  apiSrc,
  subDirectory,
  localVer,
  QRCId
};
</script>


// WEBPACK FOOTER //
// src/components/Global.vue